import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button as DesignSystemButton, IconButton, Text } from '@calm-web/design-system';

import helpFilled from 'icons/help-filled.svg';

export const HelpIcon = styled(helpFilled)`
	height: 24px;
	width: 24px;
	&&& path {
		fill: ${palette('gray6')};
	}
`;

export const Wrapper = styled(IconButton).attrs({
	tabIndex: 0,
})`
	cursor: pointer;
	padding: 0;
	height: 24px;
`;

export const Copy = styled(Text)`
	line-height: 1.5;
	margin-bottom: 18px;
`;

export const ConfirmButton = styled(DesignSystemButton)`
	width: 100%;
`;
